// extracted by mini-css-extract-plugin
module.exports = {"Projects":"ViewProjects_Projects__1dVfU","fadein":"ViewProjects_fadein__38Swb"};